export default "__VITE_ASSET__CPYQtAdV__"